import React from "react";
import { useEffect } from "react";
import { motion } from "framer-motion";
import anime from "animejs";
import "./LoadingScreen.scss";

const LoaderVariant = {
  hide: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: { delay: 1.7, duration: 1 },
  },
};
const LoadingScreen = () => {
  useEffect(() => {
    anime({
      targets: ".tri path",
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: "easeInSine",
      duration: 1700,
      delay: function (el, i) {
        return i * 100;
      },
      direction: "alternate",
      loop: false,
    });
  }, []);
  return (
    <svg
      className="tri loader"
      width="175"
      height="100"
      viewBox="0 0 168 138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99998 133L84 5L84.851 5.52521L5.85096 133.525L4.99998 133Z"
        stroke="#00FFFF"
        strokeWidth="6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164 135H5V134H164V135Z"
        stroke="#00FFFF"
        strokeWidth="6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.848 5.00003L163.848 133L163 133.53L83 5.53003L83.848 5.00003Z"
        stroke="#00FFFF"
        strokeWidth="6"
      />
      <motion.path
        variants={LoaderVariant}
        initial="hide"
        animate="show"
        d="M95.4502 100.84H73.5622L69.5302 112H62.6182L80.7622 62.104H88.3222L106.394 112H99.4822L95.4502 100.84ZM93.5782 95.512L84.5062 70.168L75.4342 95.512H93.5782Z"
        fill="#64ffda"
      />
    </svg>
  );
};

export default LoadingScreen;
